import React, { useState } from "react";
import "./Delete_Contact_Modal.css";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  faBasketShopping,
  faBuilding,
  faX,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import { setIsSignedOut } from "../../../../features/auth/authSlice";
import { useDispatch } from "react-redux";
import { getAllCart } from "../../../../features/cart/cartSlice";
import Cookies from "js-cookie";
import { updateContact } from "../../../../features/my_account/Slice";
import Success_Modal from "../success_modal/Success_Modal";

function Delete_Contact_Modal(props) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const dispatch = useDispatch();
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const handleLogOut = async () => {
    if (props?.modal_title === "Delete Contact") {
      const res = await dispatch(
        updateContact({ id: props?.id, type: props?.number })
      );
    }
    props?.onHide();
    props?.yesAction();
    if (props?.modal_title === "Log Out") {
      setShowSucsessModal(true);
      await dispatch(getAllCart(props?.isSignIn));
      Cookies.remove("Chefcut_security");
      dispatch(setIsSignedOut());
    }
    navigate('/')
  };

  return (
    <>
      <section className="modal-holder">
        {/* <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Delete_Contact_Modal modal-holder"
        >
          <Modal.Header>
            <div className="title_text">
              <p>{props?.modal_title}</p>
            </div>

            <div className="right_side">
              <img
                src="/assets/images/cart/close.png"
                className="close_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="content_holder">
              <p className="question_text">{props?.message}</p>

              <div className="btns_holder">
                <Green_Btn
                  btn_name="Yes"
                  onClick={() => {
                    handleLogOut();
                  }}
                />
                <Gray_Btn
                  btn_name="No"
                  onClick={() => {
                    props?.onHide();
                    props?.noAction();
                  }}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal> */}

        {['end'].map((placement, idx) => (
          <Offcanvas
            show={show} onHide={handleClose} {...props} key={idx} placement={placement} name={placement}
            className="Use_Current_Location_offcanvas modal-holder Delete_Contact_Modal"
          >
            <Offcanvas.Body>
              <div>
                <div className="logo_holder">
                  <img
                    src="/assets/images/header/header_logo2.png"
                    className="logo_img"
                  />
                </div>
                <div className="heading_holder">
                  <h3>{props?.modal_title}</h3>
                </div>
                <div className="address-text-holder">

                  <div className="text-holder">
                    <p>
                      {props?.message}
                    </p>
                  </div>
                </div>

                <div className="footer-btn-holder ms-0 gap-2">
                  <Green_Btn
                    btn_name="Yes"
                    onClick={() => {
                      handleLogOut();
                    }}
                  />
                  <Gray_Btn
                    btn_name="No"
                    onClick={() => {
                      props?.onHide();
                      props?.noAction();
                    }} />
                </div>
              </div>
            </Offcanvas.Body>
            <div className="overlay_holder"></div>
          </Offcanvas>
        ))}

        <Success_Modal
          show={showSuccessModal}
          onHide={() => {
            setShowSucsessModal(false);
          }}
          successText="Logged out successfully"
        />
      </section>
    </>
  );
}

export default Delete_Contact_Modal;
